@if (loading && !failed) {
    <div class="book-notice">
        <div class="spinner">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5"></div>
            <div class="rect6"></div>
            <div class="rect7"></div>
            <div class="rect8"></div>
        </div>
        <div class="book-notice-title">Buch wird geladen</div>
    </div>
}

@if (failed) {
    <div class="book-notice book-notice-fatal">
        <div class="book-notice-title">
            <i aria-hidden="true" class="fa fa-exclamation-triangle fa-2x book-notice-icon"></i><br/>
            <strong>Es tut uns leid</strong><br/>
            Das Buch konnte nicht geladen werden
        </div>
        @if (!applicationStateService.isOfflineModeEnabled) {
            <br/>
            <button (click)="goBack()" class="btn btn-round btn-open btn-semibold">
                <i aria-hidden="true" class="fa fa-caret-left"></i> Zurück
            </button>
        }
    </div>
}